

const stringUtil = require('../../string/stringUtil')
const dateUtil = require('../../dateUtil/dateUtil')
const stateManager = require('../../state/stateManager')
const settingsChangeTimestampAction = require('../../state/actions/views/settings/settingsChangeTimestampAction')
const jobsServer = require('../../jobs/jobsServer')
const rmsApiProxyRetry = require('../../api/rmsApiProxyRetry')

export function initializeSettings()
{
    var terminalSettings = stateManager.getStore().getState().terminalSettings;
    if (terminalSettings == null)
    {
        terminalSettings = {};
        stateManager.getStore().getState().terminalSettings = {};
    }

    if (stringUtil.isStringNullOrEmpty(terminalSettings.version))
    {
        transformSettings();
        saveSettings();
    }
}

export function transformSettings()
{
    var terminalSettings = stateManager.getStore().getState().terminalSettings;

    terminalSettings.version = "10.0.0";
    if (terminalSettings.displaySettings == null)
        terminalSettings.displaySettings = {};

    terminalSettings.displaySettings.cliNotificationPosition = "BottomRight";
    terminalSettings.displaySettings.orderScreenLayout = "Classic"
    terminalSettings.displaySettings.displayStorefrontSelection = true;
    terminalSettings.displaySettings.displayLoginStaffName = false;
    terminalSettings.displaySettings.displayOnScreenKeyboard = true;
    terminalSettings.displaySettings.displayInternalNotes = false;
    terminalSettings.displaySettings.layoutThemeJson = null;
    terminalSettings.displaySettings.displayScreenSaver = true;

    if (stringUtil.isStringNullOrEmpty(terminalSettings.displaySettings.menuItemLayout) || stringUtil.areStringSame(terminalSettings.displaySettings.menuItemLayout, "layoutWithImages"))
        terminalSettings.displaySettings.menuItemLayout = "LayoutWithImages"
    else if (stringUtil.areStringSame(terminalSettings.displaySettings.menuItemLayout, "layoutWithoutImages"))
        terminalSettings.displaySettings.menuItemLayout = "LayoutWithoutImages"

    if (stringUtil.isStringNullOrEmpty(terminalSettings.displaySettings.modifierLayout) || stringUtil.areStringSame(terminalSettings.displaySettings.modifierLayout, "layoutWithWizard"))
        terminalSettings.displaySettings.modifierLayout = "LayoutWithWizard"
    else if (stringUtil.areStringSame(terminalSettings.displaySettings.modifierLayout, "layoutWithColumn"))
        terminalSettings.displaySettings.modifierLayout = "LayoutWithColumn"    


    terminalSettings.controlSettings = {};
    terminalSettings.controlSettings.signatureCardAllowed = false;
    terminalSettings.controlSettings.allowOpenItems = false;
    terminalSettings.controlSettings.allowOpenDiscounts = false;
    terminalSettings.controlSettings.logoutAfterEachOrder = true;
    terminalSettings.controlSettings.logoutOnIdle = true;
    terminalSettings.controlSettings.allowAllStorefronts = false;
    terminalSettings.controlSettings.allowItemsFromMultipleStorefronts = false;
    terminalSettings.controlSettings.mandatoryDetailsBeforeOrderDetails = true;
    terminalSettings.controlSettings.printDraftSaleReceipt = false;

    
    terminalSettings.printSettings = {};
    if (terminalSettings.receiptPrinter != null && !stringUtil.isStringNullOrEmpty(terminalSettings.receiptPrinter.url))
    {
        terminalSettings.printSettings.receiptPrinter  = terminalSettings.receiptPrinter.url;
    }

    if(terminalSettings.cardSettings == null)
        terminalSettings.cardSettings = {};
    if (!stringUtil.isStringNullOrEmpty(terminalSettings.cardProviderName))
        terminalSettings.cardSettings.provider = terminalSettings.cardProviderName;

    terminalSettings.soundSettings = {};
    terminalSettings.soundSettings.newOrderSoundVolume = 1;
    
    delete terminalSettings.brandSettings;
    delete terminalSettings.cardProviderName;
    delete terminalSettings.cliSettings;
    delete terminalSettings.posSettings;
    delete terminalSettings.receiptPrinter;
    delete terminalSettings.signatureCardAllowed;
    
}

export function saveSettings()
{
    stateManager.getStore().dispatch(settingsChangeTimestampAction.createAction(dateUtil.getNow()));
    jobsServer.addJob("Settings.Save", "Settings.Save",
                      async ()=>
                      {
                            var terminal = stateManager.getStore().getState().terminal;
                            terminal.profile = {};
                            terminal.profile.settings = JSON.parse(JSON.stringify(stateManager.getStore().getState().terminalSettings));
                            var resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/terminals`;
                            await rmsApiProxyRetry.post(resource, terminal);
                      }, true);
}

export function getDisplaySettings()
{
    return stateManager.getStore().getState().terminalSettings.displaySettings;
}

export function getControlSettings()
{
    return stateManager.getStore().getState().terminalSettings.controlSettings;
}

export function getPrintSettings()
{
    return stateManager.getStore().getState().terminalSettings.printSettings;
}

export function getSoundSettings()
{
    return stateManager.getStore().getState().terminalSettings.soundSettings;
}

export function getCardSettings()
{
    return stateManager.getStore().getState().terminalSettings.cardSettings;
}
